export default __webpack_public_path__ + "static/media/floorplans.cb18d84c.jpg";